export class AxAlert {
    public constructor(selector: string) {
        $(selector).on('click', '.ax-close', e => {
            $(e.delegateTarget).addClass('d-none');
        });
    }
}